<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { t9n } from '../translate.js';
  import { TS } from '../../config/translation-keys.js';
  import { show_message } from '../flash';

  export let amount = 0;
  export let options = [];
  export let displayflag = false;
  export let showpp = false;
  export let select_payment_method_label = t9n(
    TS.PAYMENT_METHOD_SELECTOR_SELECT_PAYMENT_LABEL
  );
  export let no_payment_option_text = t9n(
    TS.PAYMENT_METHOD_SELECTOR_NO_OPTIONS_TEXT
  );
  export let add_card_advice = t9n(TS.PAYMENT_METHOD_SELECTOR_ADD_CARD_TEXT);
  export let close_label = t9n(TS.PAYMENT_METHOD_SELECTOR_CLOSE_LABEL);
  export let select_label = t9n(TS.PAYMENT_METHOD_SELECTOR_SELECT_LABEL);

  let dispatch = createEventDispatcher();

  let billing;
  let cards;
  let points;
  let has_payment_option;
  let expires_label = t9n(TS.CARDS_LIST_EXPIRES_LABEL);

  const check_availabe_payment_option = () => {
    if (!showpp) {
      return cards.length > 0 || billing.length > 0;
    }
    return cards.length > 0 || billing.length > 0 || points.length > 0;
  };

  const close = e => {
    let pm = document.querySelector('[name=payment_method]:checked');
    let id = pm ? pm.value : null;
    if (id) {
      let payment_method = options.filter(item => {
        return item.id == id;
      })[0];
      dispatch('paymentmethodselected', { payment_method: payment_method });
      displayflag = false;
    } else {
      show_message(t9n(TS.PAYMENT_METHOD_SELECTOR_SELECT_TEXT), 'error');
    }
  };

  const cancel = e => {
    displayflag = false;
  };

  const init_payment_selector = () => {
    if (options && options.length > 0) {
      billing = options.filter(item => {
        return item.payment_type === 'payment_type_billing';
      });
      cards = options.filter(item => {
        return item.payment_type === 'payment_type_credit_card';
      });
      points = options.filter(item => {
        return item.payment_type === 'payment_type_pilot_points';
      });
      has_payment_option = check_availabe_payment_option();
    }
  };

  $: init_payment_selector(options);
</script>

<div class="payment-options" class:hidden={!displayflag}>
  <div class="panel">
    <div class="mdc-dialog__title">{select_payment_method_label}</div>

    <div class="mdc-dialog__content">
      <div class="auto-margin">
        {#if has_payment_option}
          {#each options as option}
            <span class="fancy-radio">
              {#if option.data && option.data.credit_card}
                <div class="mdc-radio">
                  <input
                    class="mdc-radio__native-control"
                    type="radio"
                    id={`payment-method-${option.id}`}
                    name="payment_method"
                    value={option.id} />
                  <div class="mdc-radio__background">
                    <div class="mdc-radio__outer-circle" />
                    <div class="mdc-radio__inner-circle" />
                  </div>
                  <div class="mdc-radio__ripple" />
                </div>
                <label for={`payment-method-${option.id}`} />
                <span class="payment_text">
                  {option.data.credit_card.provider}
                  {option.data.credit_card.credit_card_number}
                </span>
                {#if option.data.credit_card.expiry_year}
                <p style='margin-left: 43px;
                    font-size: 12px;
                    margin-top: -7px;
                    color: gray;'>
                  {expires_label}: {option.data.credit_card.expiry_month}/{option.data.credit_card.expiry_year}
                </p>
                {/if}
              {:else if option.data && option.data.pilot_points}
                {#if showpp}
                  <div class="mdc-radio">
                    <input
                      class="mdc-radio__native-control"
                      type="radio"
                      id={`payment-method-${option.id}`}
                      name="payment_method"
                      value={option.id} />
                    <div class="mdc-radio__background">
                      <div class="mdc-radio__outer-circle" />
                      <div class="mdc-radio__inner-circle" />
                    </div>
                    <div class="mdc-radio__ripple" />
                  </div>
                  <label for={`payment-method-${option.id}`} />
                  <span class="payment_text">
                    {t9n(option.payment_type)} ({option.data.pilot_points.amount.toFixed(2)})
                  </span>
                {/if}
              {:else}
                <!--                                <div class="mdc-radio">-->
                <!--                                    <input-->
                <!--                                           class="mdc-radio__native-control"-->
                <!--                                           type="radio"-->
                <!--                                           id={`payment-method-${option.id}`}-->
                <!--                                           name="payment_method"-->
                <!--                                           value={option.id}>-->
                <!--                                    <div class="mdc-radio__background">-->
                <!--                                        <div class="mdc-radio__outer-circle"></div>-->
                <!--                                        <div class="mdc-radio__inner-circle"></div>-->
                <!--                                    </div>-->
                <!--                                    <div class="mdc-radio__ripple"></div>-->
                <!--                                </div>-->
                <!--                                <label for={`payment-method-${option.id}`}></label>-->
                <!--                                <span class="payment_text">-->
                <!--                                    {t9n(option.payment_type)}-->
                <!--                                </span>-->
              {/if}
            </span>
          {/each}
        {:else}
          <p>{no_payment_option_text}</p>
          <p>
            {@html add_card_advice}
          </p>
        {/if}
      </div>
    </div>

    <div class="mdc-dialog__actions">
      <button
        class="mdc-button"
        id="select-payment-method-no"
        on:click={cancel}>
        {close_label}
      </button>
      {#if has_payment_option}
        <button class="mdc-button" id="select-payment-method" on:click={close}>
          {select_label}
        </button>
      {/if}
    </div>
  </div>
  <div
    class="mdc-dialog__scrim"
    style="background-color: rgba(0,0,0,.32); opacity: 1; z-index: 1" />
</div>

<style>
  .hidden {
    display: none !important;
  }

  .auto-margin {
    margin: 0 auto;
    text-align: left;
  }

  .payment-options {
    /*display: block;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/
    z-index: 2222;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    box-sizing: border-box;
  }

  .panel {
    /*margin: 15% auto 0;*/
    /*min-width: 300px;*/
    /*width: 30%;*/
    /*border: 2px solid #336699;*/
    /*padding: 1em;*/
    /*color: #336699;*/
    /*background-color: white;*/
    text-align: center;
    border-radius: 4px;
    max-height: calc(100% - 32px);
    max-width: 560px;
    min-width: 280px;
    background-color: #fff;
    background-color: var(--mdc-theme-surface, #fff);
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
      0px 24px 38px 3px rgba(0, 0, 0, 0.14),
      0px 9px 46px 8px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    pointer-events: auto;
    overflow-y: auto;
    z-index: 2;
  }

  .panel-head {
    padding: 0.5em;
    margin-bottom: 1em;
    border-bottom: 1px solid #336699;
  }

  .panel-head h4 {
    text-align: center;
    font-weight: bold;
    color: #336699;
  }

  .panel-body {
    padding: 1em 1em 2em;
    text-align: left;
  }

  .panel-body .payment_text {
    display: inline-block;
    margin-left: 1em;
    line-height: 1.5em;
  }

  .panel-footer {
    border-top: 1px solid #336699;
    padding: 1em;
    margin-top: 1em;
    text-align: right;
  }

  .panel-footer button {
    color: #336699;
    padding: 5px 10px;
    border: 2px solid #336699;
    margin: 0 0.5em;
    border-radius: 3px;
  }

  .panel-footer button:hover {
    color: white;
    background-color: #336699;
    font-weight: bold;
    outline: 0;
  }

  .panel-footer button:focus {
    outline: 0;
  }

  .fancy-radio {
    display: block;
    position: relative;
    /*padding-left: 35px;*/
    margin-bottom: -12px;
    cursor: pointer;
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .fancy-radio label {
    background-color: rgba(51, 102, 153, 0.15);
  }

  .fancy-radio label:hover,
  .fancy-radio input:checked ~ label {
    background-color: rgba(51, 102, 153, 0.65);
  }

  .mdc-dialog__content {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
    letter-spacing: 0.03125em;
    text-decoration: inherit;
    text-transform: inherit;
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0;
    padding: 20px 24px;
    padding-top: 20px;
    overflow: auto;
    min-width: 380px;
    -webkit-overflow-scrolling: touch;
  }

  /*!* this is needed for radio label / span to be in line with radiobutton *!*/
  /*.align-radio {*/
  /*  display: inline-flex;*/
  /*  align-items: center;*/
  /*}*/

  .payment_text {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
  }
</style>
